// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import check from '../../../../../../assets/img/new-order/product-step/check.png';

import style from './ProgressBar.scss';

type Props = {
  percent: number;
};

export default function ProgressBar(props: Props) {
  const {percent} = props;
  const completed = percent === 100;
  return (
    <div className={classNames(style.progressBarWrap, {[style.completed]: completed})}>
      <div className={style.bar}>
        <div className={style.full} style={{width: `${percent.toFixed(2)}%`}} />
      </div>
      <div className={style.rightWrap}>
        {!completed && <span className={style.percent}>{percent} %</span>}
        {completed && <img className={style.check} src={check} alt="check"/>}
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/NewProductForm/ProgressBar/ProgressBar.jsx